module.exports = __webpack_public_path__ + "img/PPID.31907d91.png";